import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { License } from "@/types/models";
import api, { ApiCatalog } from "@/api";
import { User as UserV3 } from "@/types/models/User/v3/User.interface";

interface ParamsToRetrieveUserLicenses {
  userUniqueId: UserV3["unique_id"] | undefined;
  enabled?: boolean;
}

type QueryResult = License[];

const useGetLicenses = ({
  userUniqueId,
  enabled = false,
}: ParamsToRetrieveUserLicenses): UseQueryResult<QueryResult, Error> => {
  return useQuery({
    enabled,
    queryKey: [ApiCatalog.license.key, userUniqueId],
    queryFn: async () => {
      const results = await api().get(ApiCatalog.license.endpoint, {
        urlReplacers: [{ id: userUniqueId }],
      });

      return results;
    },
  });
};

export default useGetLicenses;
